package com.eladfinish.bible.contest.screens.browse.usecases

import com.eladfinish.bible.contest.common.ChaptersRepository
import com.eladfinish.bible.contest.common.usecases.MakeOtiotPasukSmallerUseCase
import com.eladfinish.bible.contest.constants.StringConstants.ALL_CHAPTERS
import com.eladfinish.bible.contest.constants.StringConstants.NEW_LINE
import com.eladfinish.bible.contest.data.ChapterData
import com.eladfinish.bible.contest.data.common.AssetReader
import com.eladfinish.bible.contest.domain.BooksRepository

class GetContentForBibleModeUseCase(
    private val prepareChapterContentForDisplayUseCase: PrepareChapterContentForDisplayUseCase,
    private val makeOtiotPasukSmallerUseCase: MakeOtiotPasukSmallerUseCase,
    private val assetReader: AssetReader,
) {

    operator fun invoke(
        bookIndex: Int,
        partIndex: Int,
    ): ChapterData {
        val bookNameEnglish = BooksRepository.bookNamesEnglish[bookIndex - 1]
        val paddedChapter = ChaptersRepository.padNumber(bookNameEnglish, partIndex)
        val fileName = ChaptersRepository.getFileFormat(
            number = bookIndex,
            bookName = bookNameEnglish,
            chapter = paddedChapter,
        )
        val fullPath = ALL_CHAPTERS + assetReader.fileSeparator + fileName
        val raw = assetReader.readFile(fileName = fullPath)
            .trim()
            .substringAfter(NEW_LINE)
        val text = prepareChapterContentForDisplayUseCase(
            rawText = raw,
            isTikunKorim = false, // תעביר true כשזה Tikun Korim
        )
        return ChapterData(
            bookIndex = bookIndex,
            chapterIndex = partIndex,
            content = text,
            spannedRangeList = makeOtiotPasukSmallerUseCase(charSequence = text),
        )
    }
}
